import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: resolve => require(['@/components/HelloWorld'], resolve)
    },
    {
      path: '/',
      name: 'first',
      component: resolve => require(['@/view/first/first'], resolve),
      meta: {
        title: '订单查询',
        // noWx: true, // 调试用，需要注释
        noLogin: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/view/login/login'], resolve),
      meta: {
        // noWx: true, // 调试用，需要注释
        noLogin: true,
        title: '登录'
      }
    },
    {
      path: '/orderQuery',
      name: 'orderQuery',
      component: resolve => require(['@/view/orderQuery/orderQuery'], resolve),
      meta: {
        // noWx: true, // 调试用，需要注释
        // noLogin: true,
        title: '订单查询'
      }
    },
    {
      path: '/completeDetails',
      name: 'completeDetails',
      component: resolve => require(['@/view/details/completeDetails'], resolve),
      meta: {
        // noWx: true, // 调试用，需要注释
        title: '订单详情'
      }
    },
    {
      path: '/otherDetails',
      name: 'otherDetails',
      component: resolve => require(['@/view/details/otherDetails'], resolve),
      meta: {
        // noWx: true, // 调试用，需要注释
        // noLogin: true,
        title: '订单详情'
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: resolve => require(['@/view/aboutUs/aboutUs'], resolve),
      meta: {
        title: '关于我们',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/download',
      name: 'download',
      component: resolve => require(['@/view/downLoad/download'], resolve),
      meta: {
        title: '下载',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/downloadPc',
      name: 'downloadPc',
      component: resolve => require(['@/view/downLoad/download2'], resolve),
      meta: {
        title: '下载',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/download1',
      name: 'download1',
      component: resolve => require(['@/view/downLoad/download1'], resolve),
      meta: {
        title: '下载',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/downloadPage',
      name: 'downloadPage',
      component: resolve => require(['@/view/downLoad/downloadPage'], resolve),
      meta: {
        title: '下载',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/driverDownLoad',
      name: 'driverDownLoad',
      component: resolve => require(['@/view/downLoad/driverDownLoad'], resolve),
      meta: {
        title: '下载',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/customerDownLoad',
      name: 'customerDownLoad',
      component: resolve => require(['@/view/downLoad/customerDownLoad'], resolve),
      meta: {
        title: '下载',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: resolve => require(['@/view/invitation/invitation'], resolve),
      meta: {
        title: '分享有礼',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/driverShare',
      name: 'driverShare',
      component: resolve => require(['@/view/invitation/driverShare'], resolve),
      meta: {
        title: '分享有礼',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/driverLogin',
      name: 'driverLogin',
      component: resolve => require(['@/view/share/driverLogin.vue'], resolve),
      meta: {
        title: '分享登录',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/sharePage',
      name: 'sharePage',
      component: resolve => require(['@/view/share/sharePage'], resolve),
      meta: {
        title: '拉新有礼',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/topUpAgreement',
      name: 'topUpAgreement',
      component: resolve => require(['@/view/agreement/topUpAgreement'], resolve),
      meta: {
        title: '充值协议',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/regularInspection',
      name: 'regularInspection',
      component: resolve => require(['@/view/agreement/regularInspection'], resolve),
      meta: {
        title: '常规查验服务义务和责任',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: resolve => require(['@/view/agreement/userAgreement'], resolve),
      meta: {
        title: '用户注册协议',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/driverAgreement',
      name: 'driverAgreement',
      component: resolve => require(['@/view/agreement/driverAgreement'], resolve),
      meta: {
        title: '司机注册协议',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/couponShopAgreement',
      name: 'couponShopAgreement',
      component: resolve => require(['@/view/agreement/couponShopAgreement'], resolve),
      meta: {
        title: '活动规则',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/customerInvited',
      name: 'customerInvited',
      component: resolve => require(['@/view/employeesInvited/customerInvited'], resolve),
      meta: {
        title: '邀请客户',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/driverInvited',
      name: 'driverInvited',
      component: resolve => require(['@/view/employeesInvited/driverInvited'], resolve),
      meta: {
        title: '邀请司机',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/insuranceAgreement',
      name: 'insuranceAgreement',
      component: resolve => require(['@/view/agreement/insuranceAgreement'], resolve),
      meta: {
        title: '货运服务协议',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/companyIntroduce',
      name: 'companyIntroduce',
      component: resolve => require(['@/view/companyIntroduce/companyIntroduce'], resolve),
      meta: {
        title: '公司介绍',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/privacyAgreement',
      name: 'privacyAgreement',
      component: resolve => require(['@/view/agreement/privacyAgreement'], resolve),
      meta: {
        title: '隐私协议',
        noLogin: true,
        noWx: true
      }
    },
    // ----------------------
    {
      path: '/privacyAgreementDriver',
      name: 'privacyAgreementDriver',
      component: resolve => require(['@/view/agreement/privacyAgreementDriver'], resolve),
      meta: {
        title: '隐私协议',
        noLogin: true,
        noWx: true
      }
    },
    // ----------------------
    {
      path: '/generation',
      name: 'generation',
      component: resolve => require(['@/view/generation/generation'], resolve),
      meta: {
        title: '求付款',
        noLogin: true,
        noWx: false
      }
    },
    {
      path: '/placeOrder',
      name: 'placeOrder',
      component: resolve => require(['@/view/placeOrder/placeOrder'], resolve),
      meta: {
        title: '下单',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/404',
      name: 'error',
      component: resolve => require(['@/view/error/error'], resolve),
      meta: {
        title: '404',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/401',
      name: 'error1',
      component: resolve => require(['@/view/error/error1'], resolve),
      meta: {
        title: '错误',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/consign',
      name: 'consign',
      component: resolve => require(['@/view/agreement/consign'], resolve),
      meta: {
        title: '托运险资费',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/yiyantang',
      name: 'yiyantang',
      component: resolve => require(['@/view/yiyantang/yiyantang'], resolve),
      meta: {
        title: '益颜堂',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/userTopUpAgreement',
      name: 'userTopUpAgreement',
      component: resolve => require(['@/view/agreement/userTopUpAgreement'], resolve),
      meta: {
        title: '充值协议',
        noLogin: true,
        noWx: true
      }
    },
    {
      path: '/withdrawAgreement',
      name: 'withdrawAgreement',
      component: resolve => require(['@/view/agreement/withdrawAgreement'], resolve),
      meta: {
        title: '鹿叭叭积分提现协议',
        noLogin: true,
        noWx: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js